<template>
  <div id="subVeri" style="background: white;">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <br/>
    <div class=" fontSizeClass leftMargin topMarginHalf columns is-mobile">
      <div class="column is-5">
        <b>Product :</b>
      </div>
      <div class="column is-7">
        {{productName}}
      </div>
    </div>
    <div class="fontSizeClass leftMargin columns is-mobile">
      <div class="column is-5">
        <b>Unit :</b>
      </div>
      <div class="column is-7">
        {{prodBaseQuantity}} {{prodUnit}}
      </div>
    </div>
    <div class="fontSizeClass leftMargin columns is-mobile">
      <div class="column is-5">
        <b>Price :</b>
      </div>
      <div class="column is-7">
        <i class="fa fa-rupee"></i>{{subscriptionDetails.discounted_mrp}}
      </div>
    </div>
    <div v-if="isPostpaidDisabled === false" class="fontSizeClass leftMargin columns is-mobile">
      <div class="column is-5">
        <b>Payment Mode :</b>
      </div>
      <div class="column is-7">
        {{paymentModeText}}
      </div>
    </div>
     <div v-if="isOneTime === false" class="fontSizeClass leftMargin columns is-mobile">
      <div class="column is-5">
        <b>Subscription Date :</b>
      </div>
      <div class="column is-7">
        {{subDate}}
      </div>
    </div>
    <div v-if="isOneTime === false" class="fontSizeClass leftMargin columns is-mobile">
      <div class="column is-5">
        <b>Schedule :</b>
      </div>
      <div class="column is-7">
        {{scheduleText}}
      </div>
    </div>
    <div v-if="customizeQtyDisplay === false" class="fontSizeClass leftMargin columns is-mobile">
      <div class="column is-5">
        <b>Quantity :</b>
      </div>
      <div class="column is-7">
        {{subscriptionDetails.quantity}}
      </div>
    </div>
    <div v-else class="fontSizeClass leftMargin columns is-mobile">
      <div class="column is-5">
        <b>Quantity :</b>
      </div>
      <div class="column is-7">
        <!-- MTWTFSS -->
        <div style="width: 14%; float: left;">
          <div>S</div>
          <div>{{subscriptionDetails.sunday}}</div>
        </div>
        <div style="width: 14%; float: left;">
          <div>M</div>
          <div>{{subscriptionDetails.monday}}</div>
        </div>
        <div style="width: 14%; float: left;">
          <div>T</div>
          <div>{{subscriptionDetails.tuesday}}</div>
        </div>
        <div style="width: 14%; float: left;">
          <div>W</div>
          <div>{{subscriptionDetails.wednesday}}</div>
        </div>
        <div style="width: 14%; float: left;">
          <div>T</div>
          <div>{{subscriptionDetails.thursday}}</div>
        </div>
        <div style="width: 14%; float: left;">
          <div>F</div>
          <div>{{subscriptionDetails.friday}}</div>
        </div>
        <div style="width: 14%; float: left;">
          <div>S</div>
          <div>{{subscriptionDetails.saturday}}</div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
    <div v-if="isOneTime === true" class="fontSizeClass leftMargin columns is-mobile">
      <div class="column is-5">
        <b>Delivered On :</b>
      </div>
      <div class="column is-7">
        {{displayStartDate}}
      </div>
    </div>
    <div class="bottomMargin fontSizeClass leftMargin columns is-mobile">
      <div class="column is-5">
        <b>Address :</b>
      </div>
      <div v-if="dispatcherLocationFlow === false" class="column is-7" style="color: blue;">
        <u v-on:click="locationModule();">{{userDetails.address}}</u>
      </div>
      <div v-if="dispatcherLocationFlow === true" class="column is-7" style="color: gray;">
        <span>{{userDetails.address}}</span>
      </div>
    </div>
    <hr class="topMargin" style="width: 100%;">
    <div style="clear: both;"></div>
    <div style="text-align: center; margin-bottom: 1rem;">
      <select v-if="isReferrerDisplay === true" style="background: white;" v-model="referrerId">
        <option v-for-key="option in dbList" v-bind:value="option.delivery_boy_id">
          {{ option.name }}
        </option>
      </select>
    </div>
    <div style="clear: both;"></div>
    <div style="bottom: 0;/* position: fixed; */ width: 100%;">
      <div style="height: 10px; background-color: white;"></div>
      <div>
        <input v-if="isEditSubscription === false" class="buttonOnAddSubscription" value="SUBSCRIBE" type="button" v-on:click="addSubscription();">
        <input v-if="isEditSubscription === true" class="buttonOnAddSubscription" value="UPDATE" type="button" v-on:click="addSubscription();">
        <!-- <input class="buttonOnAddSubscription" value="SUBSCRIBE" type="button" v-on:click=""> -->
      </div>
    </div>
  </div>
</template>
<script>
  import DatePick from 'vue-date-pick'
  import 'vue-date-pick/dist/vueDatePick.css'
  import axios from 'axios'
  export default {
    components: {DatePick},
    data () {
      return {
        subscriptionDetails: [],
        userDetails: [],
        isFullPage: true,
        isLoading: true,
        productName: '',
        prodQuantity: '',
        prodBaseQuantity: '',
        prodUnit: '',
        paymentModeText: '',
        scheduleText: '',
        displayStartDate: '',
        subDate: '',
        isPostpaidDisabled: false,
        customizeQtyDisplay: false,
        isOneTime: false,
        isEditSub: '',
        isEditSubscription: false,
        subscriptionId: 0,
        promoCodeVerified: 'no',
        promocodeText: '',
        dispatcherLocationFlow: false,
        isReferrerDisplay: false,
        dbList: [],
        referrerId: 0
      }
    },
    created () {
      if (sessionStorage.getItem('dispatcherId') !== null) {
        this.dispatcherLocationFlow = true
      }
      if (sessionStorage.getItem('custAddress1') !== null) {
        sessionStorage.removeItem('custAddress1')
      }
      if (sessionStorage.getItem('custAddress2') !== null) {
        sessionStorage.removeItem('custAddress2')
      }
      // console.log(atob(this.$route.query.cn))
      this.subscriptionDetails = JSON.parse(atob(this.$route.query.cn))
      // console.log(this.subscriptionDetails.start_date)
      // debugger
      this.displayStartDate = this.subscriptionDetails.start_date.split('-').reverse().join('-')
      this.fetchData()
    },
    methods: {
      fetchData () {
        this.userInfo()
        // alert(sessionStorage.getItem('isReferrerDisplay'))
        if (sessionStorage.getItem('isReferrerDisplay') === '1' && sessionStorage.getItem('dispatcherId') !== null) {
          if (sessionStorage.getItem('role') !== null && (sessionStorage.getItem('role') === '5' || sessionStorage.getItem('role') === 5)) {
            this.referrerId = sessionStorage.getItem('dispatcherId')
            this.isLoading = false
          } else {
            this.deliveryBoyList()
          }
          // this.deliveryBoyList()
        } else {
          this.isLoading = false
        }
        this.productName = sessionStorage.getItem('productName')
        this.prodQuantity = sessionStorage.getItem('prodQuantity')
        this.prodBaseQuantity = sessionStorage.getItem('prodBaseQuantity')
        this.prodUnit = sessionStorage.getItem('prodUnit')
        this.paymentModeText = sessionStorage.getItem('paymentModeText')
        this.scheduleText = sessionStorage.getItem('scheduleText')
        this.isEditSub = sessionStorage.getItem('isEditSubscription')
        this.subDate = sessionStorage.getItem('subDate')
        this.subDate = this.subDate.split('-').reverse().join('-')
        if (this.isEditSub === 'yes') {
          this.isEditSubscription = true
        } else {
          this.isEditSubscription = false
        }
        this.subscriptionId = sessionStorage.getItem('subscriptionId')
        this.promoCodeVerified = sessionStorage.getItem('promoCodeVerified')
        this.promocodeText = sessionStorage.getItem('promocodeText')
        if (this.subscriptionDetails.delivery_frequency === '1') {
          this.customizeQtyDisplay = true
        } else {
          this.customizeQtyDisplay = false
        }
        if (this.subscriptionDetails.type === 'One Time') {
          this.isOneTime = true
        } else {
          this.isOneTime = false
        }
        if (sessionStorage.getItem('isPostpaidDisabled') === 'yes') {
          this.isPostpaidDisabled = true
        } else {
          this.isPostpaidDisabled = false
        }
      },

      userInfo () {
        const params = new URLSearchParams()
        params.append('user_id', this.subscriptionDetails.user_id)
        axios({
          url: process.env.BASE_API + '/users/user-info',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          // console.log(response)
          this.userDetails = {}
          this.userDetails.address = response.data.user_record.address.address1
          /* this.userDetails.userId = userId
          this.userDetails.first_name = response.data.user_record.user_details.first_name
          this.userDetails.mobile = response.data.user_record.user.username
          this.userDetails.pincode = response.data.user_record.address.pincode
          this.userDetails.zombie = response.data.user_record.user_details.zombie
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          } */
        })
        .catch(e => {
          alert('not ok')
        })
      },

      deliveryBoyList () {
        const params = new URLSearchParams()
        params.append('dispatcher_id', sessionStorage.getItem('dispatcherId'))
        params.append('d_date', 'today')
        axios({
          url: process.env.BASE_API + '/dispatchers/delivery-boy-list',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.dbList = response.data.db_list
          // console.log(this.dbList)
          let selectDb = {
            'delivery_boy_id': 0,
            'name': 'Referred By(DB)'
          }
          this.dbList.unshift(selectDb)
          this.isReferrerDisplay = true
          this.isLoading = false
        })
        .catch(e => {
          alert('not ok')
        })
      },

      locationModule () {
        // alert('location')
        sessionStorage.setItem('userId', this.subscriptionDetails.user_id)
        sessionStorage.setItem('isProfile', 1)
        sessionStorage.setItem('actionName', 'subscription')
        sessionStorage.setItem('callbackUrlForSubscription', document.URL)
        sessionStorage.setItem('locationAction', 'getOldLocation')
        this.$router.push('/a/location')
      },

      addSubscription () {
        // alert('addSubscription hit')
        /* alert('user_id' + this.userId)
        alert('product_id' + this.productId)
        alert('start_date' + this.subDate)
        alert('subscription_type' + this.subPaymentMode)
        alert('quantity' + this.quantityValue) */
        /* alert('everydayCheckbox' + this.everydayCheckbox)
        alert('customizeCheckbox' + this.customizeCheckbox)
        alert('alternateCheckbox' + this.alternateCheckbox) */
        const params = new URLSearchParams()
        if (this.isEditSubscription === true) {
          params.append('isUpdate', 1)
          params.append('subscription_id', this.subscriptionId)
        }
        if (sessionStorage.getItem('isReferrerDisplay') === '1' && this.referrerId !== 0) {
          params.append('sales_executive', this.referrerId)
        }
        params.append('user_id', this.subscriptionDetails.user_id)
        params.append('product_id', this.subscriptionDetails.product_id)
        params.append('start_date', this.subscriptionDetails.start_date)
        params.append('subscription_type', this.subscriptionDetails.subscription_type)
        params.append('product_price_id', this.subscriptionDetails.product_price_id)
        params.append('is_ring_bell', this.subscriptionDetails.is_ring_bell)
        params.append('nice_to_have_req', this.subscriptionDetails.nice_to_have_req)
        if (this.subscriptionDetails.delivery_frequency === '3' && this.subscriptionDetails.type === 'Daily') {
          sessionStorage.setItem('scheduleText', 'Everyday')
          params.append('type', 'Daily')
          params.append('delivery_frequency', 3)
          params.append('quantity', this.subscriptionDetails.quantity)
        } else if (this.subscriptionDetails.delivery_frequency === '1') {
          sessionStorage.setItem('scheduleText', 'Customize')
          params.append('type', 'Daily')
          params.append('delivery_frequency', 1)
          params.append('monday', this.subscriptionDetails.monday)
          params.append('tuesday', this.subscriptionDetails.tuesday)
          params.append('wednesday', this.subscriptionDetails.wednesday)
          params.append('thursday', this.subscriptionDetails.thursday)
          params.append('friday', this.subscriptionDetails.friday)
          params.append('saturday', this.subscriptionDetails.saturday)
          params.append('sunday', this.subscriptionDetails.sunday)
        } else if (this.subscriptionDetails.delivery_frequency === '2') {
          sessionStorage.setItem('scheduleText', 'Alternate')
          params.append('type', 'Daily')
          params.append('delivery_frequency', 2)
          params.append('quantity', this.subscriptionDetails.quantity)
          params.append('alternate', this.subscriptionDetails.alternate)
        } else {
          // for one time
          sessionStorage.setItem('scheduleText', 'One Time')
          params.append('type', 'One Time')
          params.append('delivery_frequency', 3)
          params.append('quantity', this.subscriptionDetails.quantity)
        }
        if (this.promoCodeVerified === 'yes') {
          params.append('promo_code', this.promocodeText)
        }
        if (sessionStorage.getItem('dispatcherId') !== null) {
          params.append('changes_by', sessionStorage.getItem('dispatcherId'))
        } else {
          params.append('changes_by', this.subscriptionDetails.user_id)
        }
        // console.log(params)
        axios({
          url: process.env.BASE_API + '/subscriptions/add',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          // console.log(response)
          if (response.data.status === '000000') {
            this.$toast.open({
              message: response.data.msg,
              type: 'success'
            })
            // debugger
            // send to product list
            // window.location.href = response.data.product_list_url
            // debugger
            if (sessionStorage.getItem('productListUrl') !== null) {
              var path = sessionStorage.getItem('productListUrl')
              sessionStorage.removeItem('ringOnSelected')
              sessionStorage.removeItem('nice_to_have_req')
              sessionStorage.removeItem('subPaymentMode')
              sessionStorage.removeItem('subDate')
              sessionStorage.removeItem('scheduleText')
              sessionStorage.removeItem('isPostpaidDisabled')
              sessionStorage.removeItem('promoCodeVerified')
              sessionStorage.removeItem('promocodeText')
              sessionStorage.removeItem('prodQuantity')
              sessionStorage.removeItem('prodBaseQuantity')
              sessionStorage.removeItem('alternate')
              sessionStorage.removeItem('monQty')
              sessionStorage.removeItem('tueQty')
              sessionStorage.removeItem('wedQty')
              sessionStorage.removeItem('thuQty')
              sessionStorage.removeItem('friQty')
              sessionStorage.removeItem('satQty')
              sessionStorage.removeItem('sunQty')
              window.location.href = path
            }
            // this.$router.push({path: '/a/productList'})
          } else {
            this.$toast.open({
              message: response.data.msg,
              type: 'error'
            })
          }
        })
        .catch(e => {
          alert('not ok')
        })
      }
    }
  }
</script>
<style>
  #subVeri .leftMargin{
    margin-left: 5%;
  }
  #subVeri .fontSizeClass{
    font-size: 13px;
  }
  #subVeri .bottomMargin{
    margin-bottom: 1.5rem;
  }
  #subVeri .buttonOnAddSubscription {
    background-color: #3CB6C3;
    padding: 2% 17% 2% 18%;
    width: 100%;
    color: white;
    border: none;
  }
  #subVeri .columns:not(:last-child) {
    margin-bottom: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/SubscriptionVerification.vue